import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GameSelectionDialog from './GameSelectionDialog';
import './DrillsGames.css';

const DrillsGames = () => {
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);

  const handleGameClick = (gameType) => {
    if (gameType === 'recall') {
      setSelectedGame('recall');
      setShowDialog(true);
    } else if (gameType === 'cue') {
      setSelectedGame('cue');
      setShowDialog(true);
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setSelectedGame(null);
  };

  const handleGameStart = (tagId, gameType, selectedTagIds = [], totalQuestions = 10, drillContext = {}, llmModel = '') => {
    // Navigate to drill session with the selected tag and game type
    if (gameType === 'recall') {
      navigate(`/drills/recall/${tagId}`, { state: { totalQuestions, drillContext, llmModel } });
    } else if (gameType === 'cue') {
      // For cue game, we'll pass selected tags via state or URL params
      navigate(`/drills/cue/${tagId}`, { state: { selectedTagIds, totalQuestions, drillContext, llmModel } });
    }
  };

  return (
    <div className="drills-games">
      <div className="drills-games-header">
        <h2>Drill Modes</h2>
        <p>Short, quiz-style sessions for recall and cue response practice.</p>
      </div>

      <div className="games-grid">
        <div 
          className="game-card recall-game"
          onClick={() => handleGameClick('recall')}
        >
          <div className="game-icon">RC</div>
          <h3>Recall Drill</h3>
          <p>Test raw recall with timed questions and quick score feedback.</p>
          <div className="game-status active">Available</div>
        </div>

        <div 
          className="game-card cue-game"
          onClick={() => handleGameClick('cue')}
        >
          <div className="game-icon">CQ</div>
          <h3>Cue Drill</h3>
          <p>Work through scenario prompts and compare your response quality.</p>
          <div className="game-status active">Available</div>
        </div>
      </div>

      {showDialog && (
        <GameSelectionDialog
          gameType={selectedGame}
          onClose={handleDialogClose}
          onStart={handleGameStart}
          showQuestionCountSelector
          showDrillContextSelector
        />
      )}
    </div>
  );
};

export default DrillsGames;
